import { DetailScrollReveal } from '~/ui-rocco/pages/detail-shared';
import { ProfessionalVideosGridSection } from './sections/ProfessionalVideosGridSection';
import { ProfessionalContactSection } from './sections/ProfessionalContactSection';

/**
 * BC-4572 — revamped professional Videos tab (/videos).
 *
 * Same editorial shell as the other revamped tabs (hero, sub-nav, "Talk to us"
 * and the About-ArchiPro closing), with a click-to-play video tile grid as the
 * body. Rendered behind the revamp flag; the route merges overview-shaped data
 * with the videos result so the reused sections + the grid get what they read.
 */
export const ProfessionalVideosPageRevamp = () => {
    return (
        <main
            id="main-content"
            data-testid="professional-videos-page-revamp"
            className="bg-ground ground-grey max-md:pb-16 md:pb-[6.25rem]"
        >
            <DetailScrollReveal>
                <ProfessionalVideosGridSection />
            </DetailScrollReveal>
            <ProfessionalContactSection leadingSpacerHeight={120} />
        </main>
    );
};
